import { Link, SectionMessage, Text } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface VatExemptionMentionProps {
  onOpenModal: () => void
  vatExemptionMentionScheme?: string | null
  isLocalVatRate?: boolean
}

export const VatExemptionMention = ({
  onOpenModal,
  vatExemptionMentionScheme,
  isLocalVatRate,
}: VatExemptionMentionProps): ReactElement => {
  const { t } = useTranslation()

  const handleOpenModalClick = useCallback(() => {
    onOpenModal()
  }, [onOpenModal])

  const { title, link, showSectionMessage } = useMemo(() => {
    if (!isLocalVatRate) {
      return {
        title: t('external_invoices.editor.summary.vat_exemption_mention.title'),
        link: t('external_invoices.editor.summary.vat_exemption_mention.learn_more'),
        showSectionMessage: false,
      }
    }
    if (vatExemptionMentionScheme) {
      return {
        title: t('settings.organization.external_invoice.general.vat_exemption_mention.added.title'),
        link: t('settings.organization.external_invoice.general.vat_exemption_mention.edit'),
        showSectionMessage: false,
      }
    }
    return {
      title: t('settings.organization.external_invoice.general.vat_exemption_mention.title'),
      link: t('settings.organization.external_invoice.general.vat_exemption_mention.add_mention'),
      showSectionMessage: true,
    }
  }, [isLocalVatRate, vatExemptionMentionScheme, t])

  const vatExemptionMentionMessage = (
    <Text as="span" variant="bodySM">
      {title}{' '}
      <Link onClick={handleOpenModalClick}>
        <Text as="span" variant="bodySM" weight="medium">
          {link}
        </Text>
      </Link>
    </Text>
  )

  if (!showSectionMessage) {
    return vatExemptionMentionMessage
  }

  return (
    <Styled.SectionMessageWrapper>
      <SectionMessage>{vatExemptionMentionMessage}</SectionMessage>
    </Styled.SectionMessageWrapper>
  )
}
